module.exports = __webpack_public_path__ + "static/media/map_2.1af6147d.svg";